import { apiGetWithCursor } from '../../core/index.js'
import type { FacilityActivity, FacilityActivityPage, FacilityActivityRequest } from '../index.js'

/**
 * How the activity card reads a facility's activity. The operator dashboard
 * and the admin's facility dialog show the same card over different
 * endpoints and credentials, so the card is written against this rather
 * than against either (the same arrangement as BehaviorsApi).
 */
export interface FacilityActivityApi {
  /** Identifies whose facility this is, for the query cache. */
  queryKey: readonly unknown[]
  /** The path shown beside the heading, to a SeeWhoCares admin only. */
  endpoint: string
  load(request: FacilityActivityRequest): Promise<FacilityActivityPage>
}

const PAGE_SIZE = 10

/** The query string for one reading: the page size, plus whichever of an earlier start, a filter and a cursor apply. */
export function facilityActivityQuery({ since, filter, cursor }: FacilityActivityRequest): string {
  const params = new URLSearchParams({ limit: String(PAGE_SIZE) })
  if (since !== null) {
    params.set('since', since)
  }
  if (filter !== null) {
    params.set('filter', filter)
  }
  if (cursor !== null) {
    params.set('cursor', cursor)
  }
  return `?${params.toString()}`
}

/** The signed-in operator's or facility administrator's own reading. */
export function operatorFacilityActivityApi(facilityId: string): FacilityActivityApi {
  return {
    queryKey: ['facility-activity', facilityId],
    endpoint: 'GET /facilities/{facilityId}/activity',
    load: async (request) => {
      const { data, nextCursor } = await apiGetWithCursor<FacilityActivity>(`/facilities/${encodeURIComponent(facilityId)}/activity${facilityActivityQuery(request)}`)
      return { activity: data, nextCursor }
    },
  }
}
